import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const Frame = ({ src, alt, label, className, frame, y, testid }) => (
  <Reveal className={`min-w-0 ${className}`}>
    <figure data-testid={testid} className={`group relative w-full overflow-hidden rounded-[4px] ring-1 ring-black/10 ${frame}`}>
      <motion.img
        style={{ y }}
        src={src}
        alt={alt}
        loading="lazy"
        className="absolute inset-0 h-full w-full scale-[1.2] object-cover transition-[filter] duration-700 group-hover:brightness-110"
      />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_40%,rgba(0,0,0,0.6))]" />
      <figcaption className="absolute bottom-4 left-4 rounded-full bg-black/60 px-4 py-1.5 text-xs tracking-[0.2em] uppercase text-[#f3e5ab] backdrop-blur-md">
        {label}
      </figcaption>
    </figure>
  </Reveal>
);

export const Gallery = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["6%", "-6%"]);

  return (
    <section id="galeria" ref={ref} className="bg-[#f5f2ea] text-[#0a0a0b] py-24 sm:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-14 flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="text-xs tracking-[0.3em] uppercase text-[#8a6a14]">
              Galeria
            </div>
            <h2 className="mt-6 font-serif text-5xl leading-[1] sm:text-7xl">
              Trabalhos <span className="italic text-[#8a6a14]">assinados</span>
            </h2>
          </div>
          <p className="max-w-sm text-base text-zinc-700">Resultados reais, feitos no nosso salão.</p>
        </Reveal>
        <div className="grid grid-cols-1 gap-5 md:grid-cols-12 md:gap-6">
          <Frame testid="gallery-cabelo" className="md:col-span-6 md:row-span-2 md:h-full" frame="aspect-[4/5] md:aspect-auto md:h-full" src="/img/cabelo.webp" alt="Balayage loiro" label="Balayage" y={y1} />
          <Frame testid="gallery-unhas-nude" className="md:col-span-6" frame="aspect-[4/3]" src="/img/unhas-nude.webp" alt="Unhas nude com detalhe dourado" label="Nude & ouro" y={y2} />
          <Frame testid="gallery-unhas-escuras" className="md:col-span-6" frame="aspect-[4/3]" src="/img/unhas-escuras.webp" alt="Unhas castanho escuro" label="Gloss chocolate" y={y1} />
        </div>
      </div>
    </section>
  );
};
